import {
  Image as HeroImage,
  ImageProps as HeroImageProps,
} from "@heroui/react";

export type ImageProps = HeroImageProps;

export function Image({ ...props }: ImageProps) {
  return <HeroImage {...props} />;
}

Image.displayName = "RecareUI.Image";
